export enum TipoNotificacao {
  NOTIFICAR_PAINEL = 1,
  NOTIFICAR_APP,
  TODOS = 3,
}
